import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionsAtendimento from "../../../domain/actions/actionsAtendimento";
// import { Paginationbar } from "reactstrap-paginationbar";
import {
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationLink,
  PaginationItem,
} from "reactstrap";
import { format } from "date-fns";
import pt from "date-fns/locale/pt";
import BotaoExcluir from "../../../components/BotaoExcluir";
import BotaoPesquisar from "../../../components/BotaoPesquisar";
import ModalApagar from "../../../components/ModalApagar";
import ModalAtencao from "../../../components/ModalAtencao";
import ModalAtivar from "../../../components/ModalAtivar";
import ModalDesativar from "../../../components/ModalDesativar";
import ModalCarregando from "../../../components/ModalCarregando";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite";

//style
import "../../../assets/styles/listarPagination.scss";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../../../assets/styles/tabela.css";
import "../../../assets/styles/pagination.css";
import { pesquisarAtendimentosBotao } from "./../../../domain/actions/actionsAtendimento";

class Listar extends Component {
  state = {
    clienteNome: "",
    statusId: "",
    solicitante: "",
    dataInicial: "", //format(new Date(), 'yyyy-MM-dd', { locale: pt })
    dataFinal: "",
    mensagem: "",
    erro: "",
    atencao: "",
    aguardando: false,
    confirmarExclusao: false,
    idParaExcluir: null,
    confirmarAtivacao: false,
    idParaAtivar: null,
    confirmarDesativacao: false,
    idParaDesativar: null,
    formularioAtencao: false,
    page: 0,
    numPages: 0,
    pesquisa: "",
  };

  ajustaDataInicio = (dataOriginal) => {
    dataOriginal
      ? this.setState({ dataInicial: dataOriginal })
      : this.setState({ dataInicial: "" });
  };

  ajustaDataFim = (dataOriginal) => {
    dataOriginal
      ? this.setState({ dataFinal: dataOriginal })
      : this.setState({ dataFinal: "" });
  };

  //Início rotina de exclusão
  abrirConfirmarExclusao(id) {
    this.setState({ confirmarExclusao: true });
    this.setState({ idParaExcluir: id });
  }

  fecharConfirmarExclusao() {
    this.setState({ confirmarExclusao: false });
  }

  apagarAtendimento() {
    this.setState({ aguardando: true });
    this.props.removerAtendimento(this.state.idParaExcluir, (retorno) => {
      if (retorno.erro.erro) {
        this.setState({ erro: retorno.erro.mensagem });
        this.setState({ aguardando: false });
      } else {
        this.setState({ mensagem: retorno.erro.mensagem });
        this.setState({ aguardando: false });
        this.fecharConfirmarExclusao();
        this.props.limparAtendimentos();
        this.pesquisarAtendimentos();
      }
    });
  }
  //Fim rotina de exclusão

  //Início rotina de ativação
  ativarAtendimento() {
    this.setState({ aguardando: true });
    this.props.ativarAtendimento(
      { id: this.state.idParaAtivar, ativo: true },
      (retorno) => {
        if (retorno.erro.erro) {
          this.setState({ erro: retorno.erro.mensagem });
          this.setState({ aguardando: false });
        } else {
          this.setState({ mensagem: retorno.erro.mensagem });
          this.setState({ aguardando: false });
          this.fecharConfirmarAtivacao();
          this.props.limparAtendimentos();
          this.pesquisarAtendimentos();
        }
      }
    );
  }

  abrirConfirmarAtivacao(id) {
    this.setState({ confirmarAtivacao: true });
    this.setState({ idParaAtivar: id });
  }

  fecharConfirmarAtivacao() {
    this.setState({ confirmarAtivacao: false });
  }
  //Fim rotina de ativação

  //Início rotina de desativação
  desativarAtendimento() {
    this.setState({ aguardando: true });
    this.props.desativarAtendimento(
      { id: this.state.idParaDesativar, ativo: false },
      (retorno) => {
        if (retorno.erro.erro) {
          this.setState({ erro: retorno.erro.mensagem });
          this.setState({ aguardando: false });
        } else {
          this.setState({ mensagem: retorno.erro.mensagem });
          this.setState({ aguardando: false });
          this.fecharConfirmarDesativacao();
          this.pesquisarAtendimentos();
          this.props.limparAtendimentos();
        }
      }
    );
  }

  criticas() {
    const { dataInicial, dataFinal } = this.state;

    if (dataInicial && dataFinal && dataFinal < dataInicial)
      return this.setState({
        atencao: {
          mensagem: "A data final não pode ser menor que a data inicial.",
        },
      });

    return true;
  }

  abrirConfirmarDesativacao(id) {
    this.setState({ confirmarDesativacao: true });
    this.setState({ idParaDesativar: id });
  }

  fecharConfirmarDesativacao() {
    this.setState({ confirmarDesativacao: false });
  }
  //Fim rotina de desativação

  fecharFormularioAtencao = () => {
    this.setState({ formularioAtencao: false });
  };

  //Início da rotina de pesquisa
  pesquisarAtendimentos = () => {
    const { clienteNome, solicitante, dataInicial, dataFinal, statusId } =
      this.state;

    this.props.pesquisarAtendimentos({
      clienteNome,
      solicitante,
      dataInicial,
      dataFinal,
      id: statusId,
    });
  };

  pesquisarAtendimentosBotao = () => {
    const { clienteNome, solicitante, dataInicial, dataFinal, statusId, page } =
      this.state;

    this.props.pesquisarAtendimentosBotao({
      clienteNome,
      solicitante,
      dataInicial: dataInicial ? dataInicial + "T01:00:00Z" : "",
      dataFinal: dataFinal ? dataFinal + "T23:59:59Z" : "",
      id: statusId,
      page,
    });
  };

  paginationHandler = () => {
    const { page } = this.state; // Current page
    const maxVisiblePages = 10; // Number of pages to display
    const numPages = this.props.atendimentosPesquisados?.page?.totalPages || 1; // Total number of pages

    let startPage = Math.max(0, page - Math.floor(maxVisiblePages / 2));
    let endPage = startPage + maxVisiblePages - 1;

    // Ensure the range doesn't exceed numPages
    if (endPage >= numPages) {
      endPage = numPages - 1;
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages.map((page) => {
      return (
        <PaginationItem
          active={this.state.page === page ? true : false}
          className={"paginationItemStyle"}
        >
          <PaginationLink
            className={"paginationLinkStyle"}
            onClick={() =>
              this.setState({ page: page }, this.pesquisarAtendimentosBotao)
            }
          >
            {page + 1}
          </PaginationLink>
        </PaginationItem>
      );
    });
  };

  onChangeInput = (field, ev) => {
    this.setState({ [field]: ev.target.value });
  };
  //Fim da rotina de pesquisa

  componentDidMount() {
    if (this.props.location.state) {
      const { clienteNome, solicitante, dataInicial, dataFinal, statusId } =
        this.props.location.state;

      this.setState(
        {
          clienteNome: clienteNome || "",
          solicitante: solicitante || "",
          dataInicial: dataInicial || "",
          dataFinal: dataFinal || "",
          statusId: statusId || "",
          page: 0,
        },
        () => {
          this.pesquisarAtendimentosBotao();
        }
      );
    } else {
      this.pesquisarAtendimentosBotao();
    }
  }

  // O CAMPO COMENTADO FILTRAVA QUANDO ALTERAVA O NOME DO CLIENTE SEM CLICAR NO BOTÃO DE PESQUISAR
  // componentDidUpdate(nextProps, prevState) {
  //   if (
  //     this.state.clienteNome !== "" &&
  //     prevState.clienteNome !== this.state.clienteNome
  //   ) {
  //     this.pesquisarAtendimentosBotao("");
  //   } else {
  //     if (
  //       !this.props.location.state.statusId &&
  //       nextProps.atendimentosPesquisados
  //     )
  //       this.pesquisarAtendimentosBotao("");
  //   }
  // }

  componentWillUnmount() {
    this.props.limparAtendimentos();
    this.props.limparAtendimento();
  }

  handlePesquisar = () => {
    this.setState({ formularioAtencao: !this.criticas() });

    if (this.criticas()) {
      this.setState({ page: 0 });
      this.props.limparAtendimentos();
      this.pesquisarAtendimentosBotao("");
    }
  };

  render() {
    const {
      clienteNome,
      solicitante,
      dataInicial,
      dataFinal,
      mensagem,
      atencao,
      aguardando,
      confirmarExclusao,
      confirmarAtivacao,
      confirmarDesativacao,
      formularioAtencao,
    } = this.state;

    var numElements = 1;
    if (
      this.props.atendimentosPesquisados &&
      this.props.atendimentosPesquisados.page.totalElements
    )
      numElements = this.props.atendimentosPesquisados.page.totalElements;

    var atendimentos = [];
    var pages = 0;

    if (
      this.props.atendimentosPesquisados &&
      this.props.atendimentosPesquisados._embedded
    ) {
      atendimentos = this.props.atendimentosPesquisados._embedded.servicos;
    }
    var qtde = atendimentos.length;
    if (qtde % 2 === 0) {
      qtde += 1;
    }

    return (
      <>
        <ModalAtencao
          isOpen={formularioAtencao}
          toggle={() => this.fecharFormularioAtencao()}
          atencao={atencao}
        />
        {/* Component modal apagar */}
        <ModalApagar
          isOpen={confirmarExclusao}
          toggle={() => this.fecharConfirmarExclusao()}
          apagar="Atendimento"
          aguardando={aguardando}
          apagarObjeto={() => this.apagarAtendimento()}
        />
        {/* Component modal ativar */}
        <ModalAtivar
          isOpen={confirmarAtivacao}
          toggle={() => this.fecharConfirmarAtivacao()}
          ativar="Atendimento"
          aguardando={aguardando}
          ativarObjeto={() => this.ativarAtendimento()}
        />
        {/* Component modal desativar */}
        <ModalDesativar
          isOpen={confirmarDesativacao}
          toggle={() => this.fecharConfirmarDesativacao()}
          desativar="Atendimento"
          aguardando={aguardando}
          desativarObjeto={() => this.desativarAtendimento()}
        />
        <div className="d-flex">
          <div className="mr-auto p-2">
            <h2 className="display-4 titulo">Listagem de Atendimentos</h2>
          </div>
          <div>
            <FormGroup>
              <BotaoPesquisar onClickPesquisar={this.handlePesquisar} />
            </FormGroup>
          </div>
        </div>
        <hr />
        <div className="form-group row">
          <div className="col-sm-3">
            <FormGroup>
              <Label for="clienteNome">Cliente</Label>
              <Input
                type="text"
                value={clienteNome}
                name="clienteNome"
                id="clienteNome"
                autoComplete="clienteNome"
                onChange={(ev) => this.onChangeInput("clienteNome", ev)}
                placeholder="Filtar pelo cliente"
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    this.handlePesquisar();
                  }
                }}
              />
            </FormGroup>
          </div>

          <div className="col-sm-3">
            <FormGroup>
              <Label for="solicitante">Solicitante</Label>
              <Input
                id="solicitante"
                name="solicitante"
                type="text"
                value={solicitante}
                autoComplete="solicitante"
                placeholder="Filtrar por Solicitante"
                onChange={(ev) => this.onChangeInput("solicitante", ev)}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    this.handlePesquisar();
                  }
                }}
              />
            </FormGroup>
          </div>

          <div className="col-sm-3">
            <FormGroup>
              <Label for="dataInicial">Início</Label>
              <Input
                type="date"
                name="dataInicial"
                id="dataInicial"
                placeholder="Data inicial"
                value={dataInicial}
                onChange={(ev) => this.ajustaDataInicio(ev.target.value)}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    this.handlePesquisar();
                  }
                }}
              />
            </FormGroup>
          </div>

          <div className="col-sm-3">
            <FormGroup>
              <Label for="dataFinal">Fim</Label>
              <Input
                type="date"
                name="dataFinal"
                id="dataFinal"
                placeholder="Data final"
                value={dataFinal}
                onChange={(ev) => this.ajustaDataFim(ev.target.value)}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    this.handlePesquisar();
                  }
                }}
              />
            </FormGroup>
          </div>
        </div>

        {!this.props.atendimentosPesquisados && (
          <ModalCarregando isOpen={true} pagina="Listagem de Atendimentos" />
        )}
        <Table>
          <Thead className="table_head">
            <Tr>
              <Th className="text-center">ID</Th>
              <Th>Cliente</Th>
              <Th>Solicitante</Th>
              <Th className="text-center">Dt. Chamado</Th>
              <Th className="text-center">Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {atendimentos.map((atendimento) => {
              var parity = qtde % 2;
              qtde = qtde - 1;

              return (
                <Tr
                  key={atendimento.id}
                  className={parity === 1 ? "odd_row" : "even_row"}
                >
                  <Td className="text-center">{atendimento.id}</Td>
                  <Td>
                    <Link
                      to={{
                        pathname: `/sac/atendimentos-alterar/${atendimento.id}`,
                        state: {
                          filtros: {
                            clienteNome: this.state.clienteNome,
                            solicitante: this.state.solicitante,
                            dataInicial: this.state.dataInicial,
                            dataFinal: this.state.dataFinal,
                            statusId: this.state.statusId,
                          },
                        },
                      }}
                    >
                      {atendimento.cliente.nome}
                    </Link>
                  </Td>
                  <Td>{atendimento.solicitante}</Td>
                  <Td className="text-center">
                    {format(
                      new Date(atendimento.dataEmissao),
                      "dd-MM-yyyy HH:mm",
                      { locale: pt }
                    )}
                  </Td>
                  <Td className="text-center ">
                    <span>
                      <BotaoExcluir
                        onClick={() =>
                          this.abrirConfirmarExclusao(atendimento.id)
                        }
                      />
                    </span>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        <br />
        {this.props.atendimentosPesquisados ? (
          <div>
            <Pagination className={css(styles.paginationContainer)}>
              {/* First Page */}
              <PaginationItem className={"paginationItemStyle"}>
                <PaginationLink
                  first
                  className={"paginationLinkStyle"}
                  onClick={() => {
                    this.setState({ page: 0 }, this.pesquisarAtendimentosBotao);
                  }}
                />
              </PaginationItem>

              {/* Previous Page */}
              <PaginationItem
                className={"paginationItemStyle"}
                disabled={
                  this.state.page === 0 || this.state.page === "0"
                    ? true
                    : false
                }
              >
                <PaginationLink
                  className={"paginationLinkStyle"}
                  previous
                  onClick={() => {
                    this.setState(
                      { page: this.state.page - 1 },
                      this.pesquisarAtendimentosBotao
                    );
                  }}
                />
              </PaginationItem>

              {this.paginationHandler()}
              <PaginationItem
                className={"paginationItemStyle"}
                disabled={this.state.page !== numElements - 1 ? false : true}
              >
                <PaginationLink
                  className={"paginationLinkStyle"}
                  next
                  onClick={() => {
                    this.setState(
                      { page: this.state.page + 1 },
                      this.pesquisarAtendimentosBotao
                    );
                  }}
                />
              </PaginationItem>

              <PaginationItem className={"paginationItemStyle"}>
                <PaginationLink
                  className={"paginationLinkStyle"}
                  last
                  onClick={() => {
                    this.setState(
                      { page: numElements - 1 },
                      this.pesquisarAtendimentosBotao
                    );
                  }}
                />
              </PaginationItem>
            </Pagination>
          </div>
        ) : (
          false
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
});

const mapStateToProps = (state) => {
  return {
    atendimentosPesquisados: state.atendimento.atendimentosPesquisados,
  };
};

export default connect(mapStateToProps, actionsAtendimento)(Listar);
